const removeVariantId = async (variantKey) => {

  let updates = {
    [variantKey]: 0
  };

  return fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  })
  .then(response => {
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

const addNewVariantId = async (variantId, quantity, sellingPlanId) => {
  let body = {
    id: variantId,
    quantity: quantity,
    selling_plan: sellingPlanId
  };

  return fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  })
  .then(response => {
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
};

const handleSubscriptionChange = async (selectElement, inputValue) => {
  const $subscriptionFlyout = selectElement.closest('.rebuy-cart__flyout-item-subscription');
  const lineItemId = $subscriptionFlyout.getAttribute('data-line-item-key');
  const quantity = $subscriptionFlyout.getAttribute('data-quantity');

  const newVariantId = parseInt(inputValue, 10);
  const sellingPlanId = selectElement.selectedOptions[0].getAttribute('data-selling-plan-id');

  // Remove old variant from cart
  await removeVariantId(lineItemId);

  // Change to new variant id
  await addNewVariantId(newVariantId, quantity, sellingPlanId);
}

const createSubscriptionSelectMockup = (sellingPlanGroups, lineItem) => {
  console.log('lineItem', lineItem);
  const oneTimeVariantId = lineItem.product.variants.find(variant => variant.title === "One-Time Purchase").id;
  return `<div class="rebuy-cart__flyout-item-subscription" data-line-item-key="${lineItem.key}" data-quantity="${lineItem.quantity}">
    <select aria-label="Subscription delivery frequency" class="rebuy-select muted">
      <optgroup label="Pay Full Price">
        <option ${lineItem.variant_title === "One-Time Purchase" ? 'selected' : ''} value="${oneTimeVariantId}">One-time only</option>
      </optgroup>
      <optgroup label="Subscribe and Save">
        ${sellingPlanGroups.map(group => {
          return `${group.selling_plans.map(plan => {
              const selected = group.variants.some(variantId => variantId === lineItem.variant_id) ? 'selected' : '';
              return `<option data-selling-plan-id="${plan.id}" value="${group.variants[0]}" ${selected}>${plan.name}</option>`;
            }).join('')}`;
        }).join('')}
      </optgroup>
    </select>
  </div>`;
};

const handleAddingSubscriptionMockUp = (cart) => {
  const rebuyCart = document.querySelector("#rebuy-cart");

  const items = cart.items();
  for (let i = 0; i < items.length; i++) {
    const lineItem = items[i];
    const $productListItem = rebuyCart.querySelectorAll(`.rebuy-cart__flyout-item`)[i];
    if (!$productListItem) {
      continue;
    }

    const $existingSelect = $productListItem.querySelector('.rebuy-cart__flyout-item-subscription');
    if ($existingSelect) {
      // Remove existing to avoid duplicates
      $existingSelect.remove();
    }

    const sellingPlanGroups = lineItem.product.selling_plan_groups;

    if (!sellingPlanGroups || sellingPlanGroups.length === 0) {
      continue;
    }
    const subscriptionSelectMockup = createSubscriptionSelectMockup(sellingPlanGroups, lineItem);
    const $flyoutItemInfo = $productListItem.querySelector('.rebuy-cart__flyout-item-info');
    $flyoutItemInfo.insertAdjacentHTML('afterend', subscriptionSelectMockup);
  }
}

document.addEventListener('rebuy:smartcart.show', async (event) => {
  const smartcart = event.detail.smartcart;
  handleAddingSubscriptionMockUp(smartcart);
});

document.addEventListener('change', function(event) {
  if (event.target && event.target.matches('.rebuy-cart__flyout-item-subscription select')) {
    const inputValue = event.target.value;

    handleSubscriptionChange(event.target, inputValue);
  }
});
